import { FC, useContext } from 'react';

import { KenoNumberTile } from '@modules/games/KenoGame/components/KenoNumberPanel/KenoNumberTile/KenoNumberTile';
import { KenoBetContext } from '@modules/games/KenoGame/context/KenoBet.context';

export const KenoAutoBetNumberPanel: FC<{
	viewOnly: boolean;
}> = ({ viewOnly }) => {
	const { selected: selectedNumbers } = useContext(KenoBetContext);

	if (!selectedNumbers?.length) {
		return null;
	}

	return (
		<div
			data-testid="kenoAutoBetNumberPanel"
			className={`grid grid-cols-[repeat(10,1fr)] gap-0.5 [.chat-wrapper_&]:flex w-full min_mobile_large:gap-1 [.chat-wrapper_&]:gap-[2px] min_mobile_medium:w-full h-auto min_mobile_medium:!justify-center [.chat-wrapper_&]:!justify-start`}
		>
			{selectedNumbers
				.slice()
				.sort((a, b) => a - b)
				.map((number, i) => (
					<KenoNumberTile
						key={i + 1}
						viewOnly={viewOnly}
						number={number}
						className="!w-full [.chat-wrapper_&]:!w-[35px] !min-w-6 !min-h-6 !aspect-square"
					/>
				))}
		</div>
	);
};
